import { render, staticRenderFns } from "./right-top-five.vue?vue&type=template&id=503d529d&scoped=true"
import script from "./right-top-five.vue?vue&type=script&lang=js"
export * from "./right-top-five.vue?vue&type=script&lang=js"
import style0 from "./right-top-five.vue?vue&type=style&index=0&id=503d529d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d529d",
  null
  
)

export default component.exports